import { mainCities } from 'constants/arrays'
import { carriagesInfo } from 'constants/objects'
import { CURRENCY_RATE_ZL, CURRENCY_RATE_CZK, CURRENCY_RATE_EUR } from 'constants/config'

export const createDateId = date => (
  `${("0" + date.getDate()).slice(-2)}_${("0" + (date.getMonth() + 1)).slice(-2)}_${date.getFullYear()}`
)

export const createReadableDate = date => (
  `${("0" + date.getDate()).slice(-2)}/${("0" + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`
)

export const createReadableDateTime = date => {
  const d = `${("0" + date.getDate()).slice(-2)}/${("0" + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`
  const t = `${("0" + date.getHours()).slice(-2)}:${("0" + date.getMinutes()).slice(-2)}`

  return `${d} ${t}`
}

export const createReturnRoute = route => {
  const routeCitiesArray = route.split('-')

  return `${routeCitiesArray[2] ? routeCitiesArray[2] + '-' + routeCitiesArray[1] : routeCitiesArray[1]}-${routeCitiesArray[0]}` // eslint-disable-line
}

export const createReturnRouteId = route => {
  const routeCitiesArray = route.split('_')

  return `${routeCitiesArray[2] ? routeCitiesArray[2] + '_' + routeCitiesArray[1] : routeCitiesArray[1]}_${routeCitiesArray[0]}` // eslint-disable-line
}

export const currencyMaker = (fromCityType, price = null, sourceId = null) => {
  let currency = fromCityType ? 'грн' : ''

  if (sourceId === "new_website") {
    return currency
  }

  if (fromCityType === 'it') {
    currency = "eur"
  } else if (fromCityType === 'cz' && price > 50 && price < 150) {
    currency = 'zl'
  } else if (fromCityType === 'cz') {
    currency = 'czk';
  } else if (fromCityType === 'pl') {
    currency = 'zl';
  }

  return currency
}

export const sortByOrder = (a, b) => {
  if (a.order < b.order) {
    return -1
  } else if (a.order > b.order) {
    return 1
  } else {
    return 0
  }
}

export const sortBy = (array, order, key, key2 = null, key3 = null) => (
  array.sort((a, b) => {
    if (b[key] === undefined) {
      return -1
    }

    if (a[key] === undefined) {
      return 1
    }

    if (order.indexOf(a[key]) > order.indexOf(b[key])) {
      return 1
    } else if (order.indexOf(a[key]) < order.indexOf(b[key])) {
      return -1
    }

    if (key2 && a[key2] > b[key2]) {
      return 1
    } else if (key2 && a[key2] < b[key2]) {
      return -1
    }

    if (key3 && order.indexOf(a[key3]) > order.indexOf(b[key3])) {
      return 1
    } else if (key3 && order.indexOf(a[key3]) < order.indexOf(b[key3])) {
      return -1
    }

    return 0
  })
)

export const getElIdFromPath = (path, id) => path.split('/')[id - 1]

export const priceMaker = (price, status, discount) => {
  let displayValue = price || ''

  if (status === 'paid') displayValue = 'Оплачено'
  if (status === 'surcharge') displayValue = +price * (+discount || 0.8)

  return displayValue
}

export const createMainCities = cities => cities.filter(city => mainCities.includes(city.label))

export const addDays = (startDate, numberOfDays) => new Date(startDate.getTime() + 24 * 60 * 60 * 1000 * +numberOfDays)

/* eslint-disable */
export const convertCurrency = (price, currency) => {
  switch (currency) {
    case "zl":
      return price * CURRENCY_RATE_ZL
    case "czk":
      return price * CURRENCY_RATE_CZK
    case "eur":
      return price * CURRENCY_RATE_EUR
    default:
      return price
  }
}
/*eslint-enable*/

export const handlePriceValue = (price, sourceId, currency) => {
  if (sourceId === 'new_website') {
    if (currency === 'zl') {
      return price / CURRENCY_RATE_ZL;
    } else if (currency === 'czk') {
      return price / CURRENCY_RATE_CZK;
    }
  }

  return price
}

export const updateSources = (sources, id, name, value) => (
  sources.map(source => {
    if (source.id === id) {
      return {
        ...source,
        [name]: value
      }
    } else {
      return source
    }
  })
)

const datediff = (first, second) => Math.round((second - first) / (1000 * 60 * 60 * 24))

export const getCarriageNum = (date, routeId) => {
  if (!routeId) return

  const route = carriagesInfo[routeId]
  const selectedDate = date.getDay() - 1

  /* eslint-disable */
  if (routeId === 'chernivtsi_plzen') {
    switch (selectedDate) {
      case -1:
        return route.phones[5]
      case 5:
        return route.phones[2]
      default:
        return route.phones[selectedDate]
    }
  } else if (routeId === 'salerno_zaporizhia') {
    return route.phones[0]
  } else if (routeId === 'zaporizhia_salerno') {
    return route.phones[0]
  } else if (routeId === 'cherkasy_plzen') {
    switch (selectedDate) {
      case -1:
        return route.phones[0]
      case 5:
        return route.phones[1]
      default:
        return
    }
  } else if (routeId === 'plzen_cherkasy') {
    switch (selectedDate) {
      case -1:
        return route.phones[0]
      case 2:
        return route.phones[1]
      default:
        return
    }
  } else if (routeId === 'kyiv_prague') {
    return route.phones[0]
  } else if (routeId === 'prague_kyiv') {
    return route.phones[0]
  } else if (routeId === 'plzen_chernivtsi') {
    switch (selectedDate) {
      case -1:
        return route.phones[5]
      case 4:
        return route.phones[0]
      case 5:
        return route.phones[4]
      default:
        return route.phones[selectedDate]
    }
    /* eslint-enable */
  } else {
    const daysDiff = datediff(route.startDate.valueOf(), date.valueOf()) + 1

    if (routeId !== 'chernivtsi_wroclaw' && routeId !== 'wroclaw_chernivtsi') {
      if (daysDiff >= 6) {
        if (daysDiff % 6 === 0) {
          return route.phones[5]
        } else {
          const value = daysDiff % 6

          return route.phones[value - 1]
        }
      }
    } else if (daysDiff >= 5) {
      if (daysDiff % 5 === 0) {
        return route.phones[4]
      } else {
        const value = daysDiff % 5

        return route.phones[value - 1]
      }
    } else if (daysDiff % 4 === 0) {
      return route.phones[3]
    } else if (daysDiff % 3 === 0) {
      return route.phones[2]
    } else if (daysDiff % 2 === 0) {
      return route.phones[1]
    } else if (daysDiff % 1 === 0) {
      return route.phones[0]
    } else {
      return null
    }
  }
}

export const getSum = (total, num) => total + num

export const getDaysInMonth = (month, year) => {
  const date = new Date(year, month, 1)
  const days = []

  while (date.getMonth() === month) {
    days.push(new Date(date))
    date.setDate(date.getDate() + 1)
  }

  return days
}

export const createDateFromDateId = dateId => {
  const splitDate = dateId.split('_')

  return new Date(splitDate[2], splitDate[1] - 1, splitDate[0])
}

export const createMonthAgo = (date = new Date()) => {
  const day = date.getDate()
  let monthAgo = date.getMonth() - 1
  let year = date.getFullYear()

  if (monthAgo < 0) {
    monthAgo = 12
    year--
  }

  return new Date(year, monthAgo, day)
}

export const createDateFromTimestamp = timestamp => new Date(timestamp * 1000)

export const createReadableTime = date => `${("0" + date.getHours()).slice(-2)}:${("0" + date.getMinutes()).slice(-2)}`

export const handlePhoneNumber = (number = '') => {
  const trimed = number.trim()

  if (!trimed) {
    return
  }

  /* eslint-disable */
  switch (true) {
    case trimed.startsWith('+380'):
      return trimed.substring(3)
    case trimed.startsWith('380'):
      return trimed.substring(2)
    case trimed.startsWith('00'):
      return trimed.substring(2)
    case trimed.startsWith('+48'):
      return trimed.substring(1)
    case trimed.startsWith('+420'):
      return trimed.substring(1)
    default:
      return trimed
  }
  /* eslint-enable */
}


// WEBPACK FOOTER //
// ./src/services/helpers.js